export const PLAYER_COLORS = [
  { name: 'red', bg: '#ef4444' },
  { name: 'green', bg: '#22c55e' },
  { name: 'blue', bg: '#3b82f6' },
  { name: 'orange', bg: '#f97316' },
  { name: 'purple', bg: '#a855f7' },
]

export const COLOR_HEX = {
  red: '#ef4444',
  green: '#22c55e',
  blue: '#3b82f6',
  orange: '#f97316',
  purple: '#a855f7',
}

export const RULES = [
  'De bal moet in zo min mogelijk slagen in de hole. Iedere slag is een punt',
  'Bereikt de bal met een slag de hole niet? Dan verder spelen waar hij blijft liggen',
  'Niet meer dan 7 slagen spelen. Hole niet bereikt? Dan 1 punt extra, 8 opschrijven',
  'Bal uit de baan? De bal terug leggen op de gele stip en 1 extra punt berekenen',
]

export const SCORE_BANDS = [
  { min: 25, max: 30, label: 'Europese recordscore' },
  { min: 30, max: 35, label: 'U speelt op kampioenspeil' },
  { min: 35, max: 45, label: 'U kunt rustig aan wedstrijden meedoen' },
  { min: 45, max: 55, label: 'Behoorlijk goed gespeeld' },
  { min: 55, max: 65, label: 'Niet slecht, maar kan beter' },
  { min: 65, max: 75, label: 'Alle begin is moeilijk, oefening baart kunst' },
  { min: 75, max: null, label: 'Hoofdzaak is dat u plezierig en sportief gespeeld hebt!' },
]